module.exports = __webpack_public_path__ + "static/media/person.a6e7dcd1.svg";